// =============================================================================
// canonicalTables.js — THIN RE-EXPORT SHIM
//
// Why this shim exists (Phase 2):
//   The registry was promoted to `@ai-insight/shared` (packages/shared) so that
//   api (prompt filtering + post-processor) and client (Evidence Library +
//   legacy-remap UX) consume the exact same source. To avoid touching every
//   existing `import '../utils/canonicalTables'` call-site in the client, we
//   keep this file as a compatibility alias.
//
// If you are editing logic, edit packages/shared/canonicalTables.js — NOT here.
//
// Why require() + named re-exports (not `export { X } from '@ai-insight/shared'`):
//   The shared package uses CommonJS (`module.exports`). Webpack 5 in CRA
//   cannot do named re-exports from a CommonJS module — it reports
//   'module has no exports'. Using require() + explicit named exports
//   preserves both API (Node require) and client (ES module) compatibility.
// =============================================================================

const _shared = require('@ai-insight/shared');

export const CANONICAL_TABLE_IDS = _shared.CANONICAL_TABLE_IDS;
export const CANONICAL_TABLE_SET = _shared.CANONICAL_TABLE_SET;
export const PAIRED_TABLES = _shared.PAIRED_TABLES;
export const LIBRARY_CATEGORIES = _shared.LIBRARY_CATEGORIES;
export const LEGACY_TABLE_MAP = _shared.LEGACY_TABLE_MAP;
export const isCanonicalTable = _shared.isCanonicalTable;
export const isLegacyTable = _shared.isLegacyTable;
export const getPairedTable = _shared.getPairedTable;
export const resolveLegacyRemap = _shared.resolveLegacyRemap;
export const getCanonicalLabel = _shared.getCanonicalLabel;
export const getTimeHistoryPairing = _shared.getTimeHistoryPairing;
